import React from 'react';
import AtlasV2ContentV2TopSection from 'src/components/AtlasV2Components/AtlasContentV2PageComponents/AtlasContentV2TopSection';
import AtlasV2ContentV2ProductGrid from 'src/components/AtlasV2Components/AtlasContentV2PageComponents/AtlasContentV2ProductGrid';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import BasePageContainer from 'src/components/CommonV2Components/BasePageContainer/BasePageContainer';
import { BEACON_CHART_SPACING } from 'src/components/Layout/Beacon/BeaconProLayoutConsts';
import { useAtlasV2TabTreatmentRedirect } from 'src/components/AtlasV2Components/Hooks/useAtlasV2TabTreatmentRedirect';

/**
 * Content Score V2 Page in content tab = content, subtab = score
 *
 */
export const AtlasContentScoreV2PageLayout = () => {
  const { isRedirecting } = useAtlasV2TabTreatmentRedirect();
  if (isRedirecting) return null;

  return (
    <BasePageContainer sx={{ marginTop: '31px' }}>
      <Flex flexDirection="column" gap={31}>
        <AtlasV2ContentV2TopSection />
        <AtlasV2ContentV2ProductGrid />
      </Flex>
    </BasePageContainer>
  );
};
